import React from "react";

//material UI
import { Grid, Typography } from "@mui/material";

//componentes
import CustomButton from "../../components/Button";

export default function HomeScreen() {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        minHeight: "100vh",
        backgroundColor: "#EDE838",
      }}
    >
      <Grid item xs></Grid>
      <Grid item xs={10}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="center"
            alignItems="start"
            sx={{
              marginTop: "4vh",
              marginBottom: {
                xs: "1.5vh",
                sm: "1.5vh",
                md: "0.5vh",
                lg: "0vh",
                xl: "0vh",
              },
            }}
          >
            <img
              src={process.env.PUBLIC_URL + "/images/mygender_logo.svg"}
              className="mygender-logo__home"
              alt="Logo oficial do projeto de investigação MyGender da Universidade de Coimbra"
            ></img>
          </Grid>
          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
              marginTop: {
                xs: "1.5vh",
                sm: "1.5vh",
                md: "1.5vh",
                lg: "0vh",
                xl: "0vh",
              },
              marginBottom: {
                xs: "1.5vh",
                sm: "1.5vh",
                md: "1.5vh",
                lg: "1vh",
                xl: "1vh",
              },
            }}
          >
            <Typography
              color={"#000000"}
              fontWeight={700}
              fontFamily={"Inter, Helvetica, sans-serif"}
              fontSize={"2.25rem"}
              lineHeight={"100%"}
            >
              Olá! :)
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="center"
            alignItems="start"
            sx={{
              marginTop: {
                xs: "1.5vh",
                sm: "1.5vh",
                md: "1.5vh",
                lg: "1vh",
                xl: "1vh",
              },
              marginBottom: {
                xs: "1.5vh",
                sm: "1.5vh",
                md: "1.5vh",
                lg: "1vh",
                xl: "1vh",
              },
            }}
          >
            <img
              src={process.env.PUBLIC_URL + "/images/home-image.svg"}
              className="center-img__home"
              alt="Imagem com partes de um puzzle com pessoas de diferentes idades e géneros a conversar."
            ></img>
          </Grid>
          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="center"
            textAlign="center"
            alignItems="start"
            sx={{
              margin: {
                xs: "0 10%",
                sm: "0 10%",
                md: "0 10%",
                lg: "0 5%",
                xl: "0 5%",
              },
            }}
          >
            <Typography
              color={"#000000"}
              fontWeight={700}
              fontFamily={"Inter, Helvetica, sans-serif"}
              fontSize={"1.5rem"}
              lineHeight={"110%"}
            >
              Testa os teus conhecimentos sobre género com o quiz MyGender!
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="center"
            textAlign="center"
            alignItems="start"
            sx={{
              marginTop: {
                xs: "0.5vh",
                sm: "0.5vh",
                md: "0.5vh",
                lg: "1vh",
                xl: "1vh",
              },
              marginBottom: {
                xs: "0.5vh",
                sm: "0.5vh",
                md: "0.5vh",
                lg: "1vh",
                xl: "1vh",
              },
            }}
          >
            <CustomButton
              path={"genderometer"}
              title={"Jogar"}
              backcolor={"#EDE838"}
              animation={"pulse 3s infinite"}
            ></CustomButton>
          </Grid>
          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="center"
            alignItems="center"
            textAlign={"center"}
            sx={{ marginBottom: "5%" }}
          >
            <Grid container spacing={2}>
              <Grid
                item
                xs
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                textAlign={"center"}
              >
                <img
                  src={process.env.PUBLIC_URL + "/images/uc_logo.svg"}
                  className="uc-logo__home"
                  alt="Logotipo da Universidade de Coimbra"
                ></img>
              </Grid>
              <Grid item xs sx={{ textAlign: "left" }}>
                <img
                  src={process.env.PUBLIC_URL + "/images/fct_logo.svg"}
                  className="fct-logo__home"
                  alt="Logotipo da Fundação para a Ciência e a Tecnologia de Portugal"
                ></img>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs></Grid>
    </Grid>
  );
}
